module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "loader"
  }), _vm._v(" "), _c('span', [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-2353060c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/index.vue
// module id = 91
// module chunks = 2